export const ApiURL = {
  // ACCOUNTS
  'ACCOUNT_OPTIMIZED': 'accounts',
  'GET_ACCOUNTINFO':'accounts/',
  'CREATE_ACCOUNT': 'accounts/createaccount',
  'GET_ACCOUNT_SALES_ACTIVTY_INFO': 'accounts/getaccountsalesactivityinfo',
  'SEND_SIGN_REQUEST': 'accounts/signrequestCheck',
  'DELETE_ACCOUNT': 'accounts/removeaccount',
  'UPDATEACCOUNT': 'accounts/updateaccount',
  'MERGE_ACCOUNT': 'accounts/mergeaccount',

  // ACCOUNT FUNCTION
  'UPDATEFUNCTIONDATE': 'accountfunctions',
  'GET_FUNCTION': 'accountfunctions',
  'COPY_FUNCTION': 'accountfunctions/copyfunction',
  'CREATEFUNCTION': 'accountfunctions/createfunction',
  'GET_FUNCTION_MASTERT_TABLES': 'accountfunctions/getMasterData',
  'GETALLACCOUNTFUNCTIONS': 'accountfunctions/getallfunction',
  'UPDATEFUNCTION': 'accountfunctions/updatefunction',
  'REMOVE_FUNCTION': 'accountfunctions/removefunction',

  // ACCOUNT NOTES
  'ACCOUNT_NOTES': 'accountnotes',
  'ACCOUNT_NOTE': 'accountnotes',
  'CREATE_ACCOUNT_NOTE': 'accountnotes',
  'UPDATE_ACCOUNT_NOTE': 'accountnotes',
  'REMOVE_ACCOUNT_NOTE': 'accountnotes',

  // ADMIN USERS
  'GETADMINUSERS': 'adminusers',
  'GETADMINDATA': 'adminusers/',
  'ADDUSER': 'adminusers/createadminuser',
  'CHANGEPASSWORD': 'adminusers/changepassword',
  'CONFIRMATION_MAIL': 'adminusers/confirmationmail',
  'ACTIVE_USER': 'adminusers/activeuser',
  'INACTIVE_USER': 'adminusers/inactiveuser',
  'LOGIN': 'adminusers/userlogin',
  'LOGOUT': 'adminusers/logout',
  'FORGOT': 'adminusers/sendotp',
  'MIGRATE_USER': 'adminusers/migrateuser',
  'UPDATEUSER': 'adminusers/updateadminuser',
  'VALIDATE': 'adminusers/verifyotp',
  'VERIFYPASSWORD': 'adminusers/verifypassword',

  // Aggrement
  'AGGREMENT': 'aggrements',
  'CREATE_AGGREMENT': 'aggrements/createAggrement',
  'DOWNLOAD_DOCUMENT': 'aggrements/documentDownload',
  'UPLOAD_PRESIGNED_URL': 'aggrements/generatePresignedUrl',
  'REMOVE_DOCUMENT': 'aggrements/removeDocument',

  // ASK_QUESTION
  'ASK_QUESTION': 'asks',
  'CREATE_ASK': 'asks/createask',
  'UPDATE_ASK': 'asks/updateask',

  // AUDIT_LOG
  'AUDIT_LOG': 'auditlogs',

  // BEO FUNCTIONS
  'BEO': 'beofunctions',
  'ADDBEO': 'beofunctions/createbeofunction',
  'GETBEO': 'beofunctions/getbeofunctiondetail',
  'UPDATEBEO': 'beofunctions/updatebeofunction',

  // BUSINESS_OPPORTUNITY
  'BUSINESS_OPPORTUNITIES': 'businessopportunities',

  // CALENDARS
  'CALENDARINFO': 'calendars/getactivitynotes',

  // CLIENT_LOGS
  'CLIENT_LOGS': 'clientlogs',

  // CONTACTS
  'CONTACT': 'contacts',
  'ADDCONTACT': 'contacts/createcontact',
  'ADDNEWCONTACT': 'contacts/createnewcontact',
  'MERGECONTACT': 'contacts/mergecontact',
  'UPDATECONTACT': 'contacts/updatecontact',

  // CONTRACT_SIGN
  'CONTRACT_SIGN': 'contractsigns',
  'GET_CLAIM_URL': 'contractsigns/getClaimUrl',
  'SEND_PDF': 'contractsigns/sendpdf',
  'GET_CONTRACT_STATUS': 'contractsigns/getReportStatus',
  'SEND_NOTIFICATION': 'contractsigns/sendNotification',
  'GET_CONTRACTS': 'contractsigns/getContracts',
  'GET_SIGN_URL': 'contractsigns/getsignurl',
  'CANCEL_REQUEST': 'contractsigns/cancelevent',
  'UPDATE_CONTRACT': 'contractsigns/signcontract',
  // CONTRACT TEMPLATES
  'GET_CONTRACT_TEMPLATES': 'contracttemplates',

  // CUTT_OFF
  'GET_CUTT_OFF_DATES': 'cutoffdates',

  // FIELD_HISTORY
  'FIELD_HISTORY': 'fieldhistories',

  // FUNCTION_CUTT_OFF
  'GET_FUNCTION_CUT_OFF_DATES': 'functioncutoffdates',

  // FUNCTION NOTES
  'FUNCTIONNOTES': 'functionnotes/createfunctionnotes',
  'UPDATEFUNCTIONNOTES': 'functionnotes/updatefunctionnotes',

  // FUNCTION_ROOM_DESIGN
  'FUNCTION_ROOM_DESIGNS': 'functionroomdesigns',
  'DELETE_ROOM_DESIGN': 'functionroomdesigns/removedesign',

  // FUNCTION SALES ACTIVITIES
  'CREATEFUNCTIONSALESACTIVITY': 'functionsalesactivities/createfunctionsalesactivity',
  'UPDATEFUNCTIONSALESACTIVITY': 'functionsalesactivities/updatefunctionsalesactivity',

  // GROUP INFO
  'GROUP_INFO': 'groupinfos',
  'ADDGROUP': 'groupinfos/creategroup',
  'GET_GROUP_DURATION_INFO': 'groupinfos/getgroupdurationinfo',
  'UPDATEGROUP': 'groupinfos/updategroup',
  'GET_MASTER_DATA': 'groupinfos/getMasterData',
  'REMOVE_GROUP': 'groupinfos/removegroup',

  // GROUP SALES ACTIVITIES
  'Group_SALES_ACTIVITY': 'groupsalesactivities',
  'ADDGROUPSALESACTIVITY': 'groupsalesactivities/createsalesactivity',
  'GETGROUPSALESACTIVITY': 'groupsalesactivities/getgroupsalesactivity',
  'UPDATEGROUPSALESACTIVITY': 'groupsalesactivities/updatesalesactivity',

  // GROUP NOTES
  'GROUP_NOTES': 'groupnotes',
  'CREATE_GROUP_NOTES': 'groupnotes/creategroupnotes',
  'UPDATE_GROUP_NOTES': 'groupnotes/updategroupnotes',

  // MEASURES
  'GET_MEASURES': 'measures',

  // MENU CATEGORIES
  'GET_MENU_CATEGORIES': 'menucategories',

  // MENU TYPES
  'GET_MENU_CODES': 'menutypes',
  'GETMENUCODESLIST': 'menutypes/getcode',

  // NOTES
  'NOTES': 'notes',
  'GET_NOTES_URL': 'notes/getnotes',
  'CREATENOTES': 'notes/createnotes',
  'CREATE_PROPERTY_NOTES': 'notes/createpropertynotes',
  'UPDATENOTES': 'notes/updatenotes',

  // NOTIFICATIONS
  'GET_LAST_FIVE_WEEKS': 'notifications/getLastFiveWeeks',
  'GET_LAST_FIVE_WEEKS_NOTIFICATION': 'notifications/getLastFiveWeeksNotification',
  'SEARCH_NOTIFICATION': 'notifications/searchNotification',

  // RATES
  'RATE': 'rates',
  'CREATERATE': 'rates/createrate',
  'UPDATERATE': 'rates/updaterate',

  // REPORT_ISSUE
  'GET_REPORT_ISSUE': 'reports',
  'CREATE_REPORT_ISSUE': 'reports/createreport',
  'UPDATE_REPORT_ISSUE': 'reports/updatereport',

  // REPORT_NOTIFICATIONS
  'GET_REPORT_NOTIFICATION': 'reportnotifications',
  'GET_CUSTOM_REPORT_NOTIFICATION':'reportnotifications/customNotifications',

  // REVENUTE CENTER
  'GET_REVENUE_CENTERS': 'revenuecenters',

  // SALES ACTIVITY
  'SALES_ACTIVITY': 'salesactivities',
  'GET_GROUP_FUNCTION_TARGET': 'salesactivities/gettargetinfo',
  'GET_GROUP_ROOM_TARGET': 'salesactivities/getroomblock',
  'UPDATEACTIONSALESACTIVITY': 'salesactivities/updateaction',
  'GETALLACTIVITY': 'salesactivities/getallsalesactivity',
  'GENERATE_REPORT': 'salesactivities/generatereport',
  'CREATESALESACTIVITY': 'salesactivities/createdsalesactivity',
  'SEARCH_SALES_ACTIVITY': 'salesactivities/searchsalesactivity',
  'UPDATESALESACTIVITY': 'salesactivities/updatesalesactivity',
  'GET_WEEKLY_TARGET': 'salesactivities/weeklytarget',
  'GET_FUTURE_SALES_ACTIVITY': 'salesactivities/futuresalesactivities',

  // SALES CALENDAR
  'SALES_CALENDARS': 'salescalendars',
  'GETSALESDATA': 'salescalendars',
  'GET_SALES_INFO': 'salescalendars/getinfo',
  'GET_SALES_INFO_ID': 'salescalendars/getinfobyid',
  'SALES_CALENDARS_ACTIVITIES': 'salescalendars/getactive',
  'CREATE_PROPERTY_SALES_CALENDAR': 'salescalendars/createnewsalescalendar',
  'CREATESALES': 'salescalendars/createsalescalendar',
  'UPDATE_PROPERTY_SALES_CALENDAR': 'salescalendars/updatepropertysalescalendar',
  'UPDATESALES': 'salescalendars/updatesalescalendar',

  // SUGGEST ENHANCEMENT
  'SUGGEST_ENHANCEMENT': 'suggests',
  'CREATE_SUGGEST_ENHANCEMENT': 'suggests/createsuggest',
  'UPDATE_SUGGEST_ENHANCEMENT': 'suggests/updatesuggest',

  // TRACKING
  'TRACK_ACCOUNT': 'trackings',
  'TRACKING': 'trackings/createtracking',
  'UPDATETRACKING': 'trackings/updatetracking',
  'REMOVE_TRACKING': 'trackings/removetracking',

  // TASK
  'CREATETASK': 'tasks/createtask',
  'GETTASK': 'tasks/gettask',
  'DELETETASK': 'tasks/updatetask',

  // USER_PERMISSION
  'USER_PERMISSION': 'userpermissions',

  //  MASTER TABLES
  'GET_ACCOUNT_TYPES_LIST': 'accounttypes',
  'GET_GROUP_BAGGAGE_TYPES': 'baggage',
  'GET_GROUP_BILLING_INSTRUCTIONS': 'billinginstructions',
  'GET_ACCOUNT_BUSINESS_LIST': 'businesscategories',
  'GET_GROUP_COMPPOLICY': 'comppolicies',
  'GET_GROUP_CANCELLATION_POLICIES': 'cancellationpolicies',
  'GET_FUNCTION_NOTES': 'functionnotes',
  'GETFUNCTIONROOMSLIST': 'functionrooms',
  'GETFUNCTIONEVENTSLIST': 'functioneventtypes',
  'GET_FUNCTION_SALES_ACTIVITY': 'functionsalesactivities',
  'GET_ACCOUNT_GROUP_TYPES_LIST': 'grouptypes',
  'GET_ACCOUNT_GROUP_STATUS_LIST': 'groupstatuses',
  'GET_ACCOUNT_GROUP_FINALSTATUS_LIST': 'groupfinalstatuses',
  'GET_ACCOUNT_GROUP_GUARANTEE_LIST': 'guarantees',
  'GET_USER_JOB_TITLE': 'jobtitles',
  'GET_ACCOUNT_TRACKING_LEADSTATUS_LIST': 'leadstatuses',
  'GET_ACCOUNT_MARKET_LIST': 'marketsegments',
  'GETMENUITEMLIST': 'menucategories',
  'GET_NOTIFICATIONS': 'notifications',
  'GET_ACCOUNT_OFFICE_TYPES_LIST': 'officetypes',
  'GET_ACCOUNT_GROUP_PARKING_LIST': 'parkings',
  'GETFUNCTIONPAYMENTLIST': 'paymentmethods',
  'GET_ACCOUNT_PRIORITY_LIST': 'priorities',
  'GET_PROPERTY_LIST': 'properties',
  'GET_UNIQUE_PROPERTY_LIST':'properties/getProperties',
  'GET_ACCOUNT_RATE_TYPES_LIST': 'ratetypes',
  'GET_ACCOUNT_RATE_SOURCE_LIST': 'ratesources',
  'GET_ACCOUNT_GROUP_RESERVATIONS_LIST': 'reservationmethods',
  'GET_GROUP_ROOM_TYPES': 'roomtypes',
  'GET_SALES_ACTIVITY_TYPES': 'salesactivitytypes',
  'GETROOMSETUPLIST': 'setups',
  'GET_ACCOUNT_GROUP_STAYTYPES_LIST': 'staytypes',
  'GET_ACCOUNT_SOURCE_LIST': 'sourcelists',
  'GET_TAGS_LIST': 'tags',
  'GET_ACCOUNT_TRACKING_TYPES_LIST': 'trackingtypes',
  'SALUTATION': 'salutations',

  // YMC USERS
  'YMC_LOGIN': 'ymcusers/userlogin',
  'YMC_SWITCH': 'ymcusers/propertyswitch',
  'YMC_CREATE_JIRA_TICKET': 'ymcusers/generatejiraticket',
  'YMC_PROPERTY_LOGIN': 'ymcusers/propertylogin',
  'YMC_CREATE_USER': 'ymcusers/createadminuser',
  'YMC_UPDATE_REPORT': 'ymcusers/updatereport',
  'YMC_UPDATE_SUGGEST': 'ymcusers/updatesuggest',
  'YMC_UPDATE_ASK': 'ymcusers/updateask',
  'VERIFY_CAPTCHA': 'ymcusers/recaptcha',
  'SEND_OTP': 'ymcusers/sendotp',
  'VERIFY_OTP': 'ymcusers/verifyotp',
  'UPDATE_USER_PASSWORD': 'ymcusers/updateuserpassword',

  // alcohol tax
  'GET_ALCOHOL_TAX':'alcoholTaxes',
};

export const LOGGED_IN_USER = '$$NGauge-LoggedInUser$$';
export const USER_INFO = '$$NGauge-UserInfo$$';
export const USER_PROPERTY = '$$NGauge-UserProperty$$';
export const USER_IP_INFO = '$$NGauge-UserIpInfo$$';
export const BACKGROUND_IMAGE_PATH = '$$NGauge-BgImagePath$$';
export const NGAUGE_PROPERTY_LOG_INFO = '$$NGauge-Property-Log-Config$$';
export const CLUSTER_ARRAY = '$$NGauge-Cluster-Array$$';
export const SINGLE_CLUSTER_PROPERTY = '$$NGauge-Single-Cluster$$';
export const CLUSTER_PERMISSION_PROPERTY = '$$NGauge-Cluster_Permission_properties$$';
export const LOGGED_IN_PROPERTY = '$$NGauge-Logged-In-Property$$';
export const ACCOUNT_INFO = '$$NGauge-Account-Info$$';
export const ACCOUNT_DATA = '$$NGauge-Account-Data$$';
export const CONTACT_DATA = '$$NGauge-Contact-Data$$';
export const ACCOUNT_ADD_EDIT_DATA = '$$NGauge-Account-AddEdit-Data$$';
export const FUNCTION_BEO = '$$NGauge-Function-Beo$$';
export const SALES_ACTIVTY_TYPE = 'account';
export const SINGLE_PROPERTY = 'Single Property';
export const AMOUNT_PATTERN = '^([0-9]{1,7})((.[0-9]{1,2})?)$';
export const EMAIL_PATTERN = /^(.+)@(.+)$/i;
export const PASSWORD_RESET_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/i;
export const WEB_ADDRESS_PATTERN =
  '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$';
export const FAX_MASK_PATTERN = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
export const PHONE_MASK_PATTERN = ['(', /[0-9X]/, /[0-9X]/, /[0-9X]/, ')', ' ', /[0-9X]/, /[0-9X]/, /[0-9X]/, '-', /[0-9X]/, /[0-9X]/, /[0-9X]/, /[0-9X]/, ' ',
  /[x]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
export const EMAIL_SUGGESTIONS = ['UNKNOWN@ngauge.com', 'unknown@ngauge.com', 'unknown@nGauge.com', 'UNKNOWN@nGauge.com'];
export const CONTRACT_RESTRICTED_DOMAINS = ['yahoo.com', 'gmail.com', 'hotmail.com', 'msn.com', 'outlook.com', 'outlook.live.com'];
export const PROSPECTING_WEEKLY_CALLS = 'Prospecting Weekly Calls - Individual';
export const PROSPECTING_WEEKLY_CALLS_TEAM = 'Prospecting Weekly Calls - Team';
export const PROSPECTING_QUARTERLY_CALLS = 'Prospecting Quarterly Calls - Individual';
export const PROSPECTING_QUARTERLY_CALLS_TEAM = 'Prospecting Quarterly Calls - Team';
export const APPOINTMENT_WEEKLY_CALLS = 'Appointment Weekly Calls - Individual';
export const APPOINTMENT_WEEKLY_CALLS_TEAM = 'Appointment Weekly Calls - Team';
export const APPOINTMENT_QUARTERLY_CALLS = 'Appointment Quarterly Calls - Individual';
export const APPOINTMENT_QUARTERLY_CALLS_TEAM = 'Appointment Quarterly Calls - Team';
export const GROUP_ROOM_NIGHT_INDIVIDUAL = 'Group “Room Night” Goal - Individual';
export const GROUP_ROOM_NIGHT_TEAM = 'Group “Room Night” Goal - Team';
export const SUPER_ADMIN = 'SuperAdmin';
export const ADMIN = 'Admin';
export const SALES_PERSON = 'SalesPerson';
export const TECH_SUPPORT = 'Tech Support';
export const PRIMARY = 'primary';
export const SECONDARY = 'secondary';
export const SALES_COORDINATOR = 'Sales Coordinator';
export const LOGIN_BACKGROUND_IMAGES = ['02.jpg', '03.jpg', '04.jpg', '05.jpg', '06.jpg', '07.jpg', '08.jpg', '09.jpg', '10.jpg',
  '11.jpg', '12.jpg', '13.jpg', '14.jpg', '15.jpg', '16.jpg', '17.jpg', '18.jpg', '20.jpg', '21.jpg', '22.jpg', '23.jpg', '24.jpg',
  '25.jpg', '26.jpg', '27.jpg', '28.jpg', '29.jpg', '30.jpg', '31.jpg', '32.jpg', '33.jpg', '34.jpg', '35.jpg', '36.jpg', '37.jpg',
  '39.jpg', '40.jpg', '41.jpg', '42.jpg', '43.jpg', '44.jpg', '45.jpg', '46.jpg', '47.jpg', '48.jpg', '51.jpg', '52.jpg', '53.jpg'];
export const FILTER_ACCOUNT_CATEGORY_TYPES = ['Account', 'City', 'Contact', 'Group', 'Sales Person', 'Segment', 'Tag', 'Zip'];
export const SALUTATIONS = ['None', 'Dr.', 'Mr.', 'Ms.', 'Mrs.'];
export const TARGET_GAUGE_DEFAULT_VALUE = {
  targetAppointment: 0,
  targetAppointmentBalance: 0,
  targetAppointmentCompleted: 0,
  targetProspecting: 0,
  targetProspectingBalance: 0,
  targetProspectingCompleted: 0
};
export const DISABLED_ACCOUNT = 'Disabled';
export const GROUP_SALES_ACTIVITY_IN_DB = ['arrivalDate', 'depositDue', 'contractDue', 'releaseDate', 'finalStatus', 'roomListDue',
  'cancellation'];
export const GROUP_SALES_ACTIVITY = ['Group Arrival', 'Group Deposit Due', 'Group Contract Due', 'Group Release Date',
  'Final Status Due', 'RoomList Due', 'Group Cancellation'];
export const FUNCTION_SALES_ACTIVITY_IN_DB = ['contractDue', 'depositDue', 'BEODue', 'guaranteeDue', 'menuDue', 'finalStatus',
  'cancellationDue'];
export const FUNCTION_SALES_ACTIVITY = ['Function Contract Due', 'Function Deposit Due', 'Function BEODue', 'Function Guarantee Due',
  'Function Menu Due', 'Final Status Sales Activity', 'Function Cancellation Due'];
export const MENU_CATEGORY_DETAILS = {
  REFRESHMENT: 'Refreshments',
  FOOD: 'Food',
  SPECIAL_REQ: 'Staff',
  AUDIO_VISUAL: 'A/V',
  ROOM_SETUP: 'Room Setup',
  BEVERAGE: 'BEV'
};
export const CORPORATE = 'corporate';
export const LOG_LEVELS = {
  INFO: 'info',
  DEBUG: 'debug',
  WARN: 'warn',
  ERROR: 'error',
  FATAL: 'fatal',
  LOG: 'log'
};
export const EDIT_PAGE = 'Edit';
export const ADD_PAGE = 'Add';
export const VIEW_PAGE = 'View';
export const PLUS_CLICK = '“+” Click';
export const LOG_MESSAGES = {
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  CLICK: 'Click',
  TOGGLE: 'Toggle',
  SHOW: 'Show',
  HIDE: 'Hide',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  REFRESH: 'Refresh',
  YES: 'Yes',
  NO: 'No'
};
export const TEXT_AREA_TOOL_TIP = 'Paste Text';
export const RATE_HISTORY_FIELDS = [{ field: 'isActive', value: 'Inactive' }];
export const GROUP_HISTORY_FIELDS = [
  { field: 'status', value: 'Status' },
  { field: 'arrivalDate', value: 'Arrival Date' },
  { field: 'nights', value: 'Nights' },
  { field: 'numberOfRoomType', value: 'Number of Room Type' },
  { field: 'Block', value: 'Block' },
  { field: 'Nett', value: 'Nett' },
  { field: 'pickupActual', value: 'Pickup Actual' },
  { field: 'pickupActual$', value: 'Pickup Actual$' },
  { field: 'adrDaily', value: 'AdrDaily' },
  { field: 'MGR', value: 'MGR' }];
export const FUNCTION_HISTORY_FIELDS = [
  { formGroup: 'functionGroup', field: 'functionDate', value: 'Function Date' },
  { formGroup: 'functionGroup', field: 'status', value: 'Status' },
  { formGroup: 'forecastGroup', field: 'totalRoomFee', value: 'Total Room Fees' },
  { formGroup: 'scheduleGroup', field: 'startDate', value: 'Start Date' },
  { formGroup: 'scheduleGroup', field: 'startTime', value: 'Start Time' },
  { formGroup: 'scheduleGroup', field: 'endDate', value: 'End Date' },
  { formGroup: 'scheduleGroup', field: 'endTime', value: 'End Time' },
  { formGroup: 'scheduleGroup', field: 'room', value: 'Room' },
  { formGroup: 'scheduleGroup', field: 'setup', value: 'Setup' },
  { formGroup: 'scheduleGroup', field: 'roomRental', value: 'Room Rental' },
  { formGroup: 'scheduleGroup', field: 'estFood', value: 'Est. Food' }];
export const BEO_HISTORY_FIELDS = [
  { formGroup: 'beoTabGroup', field: 'status', value: 'Status' },
  { formGroup: 'beoTabGroup', field: 'setFor', value: 'Set For' },
  { formGroup: 'beoTabGroup', field: 'gtdId', value: 'Gtd No' },
  { formGroup: 'beoTabGroup', field: 'gtdId', value: 'Gtd No' },
  { formGroup: 'chargesGroup', field: 'total', value: 'Charges Total' },
  { formGroup: 'menuGroup', field: 'tax1', value: 'Exempt from Tax 1' },
  { formGroup: 'menuGroup', field: 'tax2', value: 'Exempt from Tax 2' },
  { formGroup: 'menuGroup', field: 'tax3', value: 'Exempt from Tax 3' },
  { formGroup: 'menuGroup', field: 'tax4', value: 'Exempt from Tax 4' },
  { formGroup: 'menuGroup', field: 'flatTax', value: 'Exempt from Flat Tax' }];
export const CONTACT_HISTORY_FIELDS = [
  { field: 'type', value: 'Primary' },
  { field: 'isActive', value: 'Inactive' }];
export const STATUS_PROPOSAL = 'Proposal';
export const STATUS_TENTATIVE = 'Tentative';
export const STATUS_DEFINITE = 'Definite';
export const STATUS_CANCELLED = 'Cancelled';
export const FUNCTION_STATUS = [STATUS_TENTATIVE, STATUS_PROPOSAL, STATUS_DEFINITE, STATUS_CANCELLED];
export const IMAGE_PRE_TEXT = 'data:image/png;base64,';
export const PDF_PRE_TEXT = 'data:application/pdf;base64,';
export const EMPTY_IMAGE = 'iVBORw0KGgoAAAANSUhEUgAAAMUAAACDCAMAAAAK5y' +
  '+zAAAAA1BMVEX///+nxBvIAAAAMElEQVR4nO3BMQEAAADCoPVPbQ0PoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABeDGVSAAGwPCLAAAAAAElFTkSuQmCC';
const TINY_MCE_INIT = {
  plugins: 'lists advlist paste',
  toolbar: 'paste pastetext',
  paste_as_text: true,
  paste_block_drop: false,
  forced_root_block: '',
  statusbar: false,
  menubar: 'file edit format',
  paste_preprocess: function (plugin, args) {
    args.content += ' preprocess';
  }
};
export const TINY_MCE_MAIL_BODY = { width: '95.5%', ...TINY_MCE_INIT };
const useDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
export const TINY_MCE_DOC_EDIT_WINDOW = {
  plugins: 'print preview importcss searchreplace autolink autosave save directionality' +
    ' visualblocks visualchars fullscreen link codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist' +
    ' lists wordcount imagetools textpattern noneditable help' +
    ' charmap quickbars emoticons paste',
  toolbar: 'undo redo | bold italic underline strikethrough |  fontsizeselect formatselect | alignleft aligncenter alignright' +
    ' alignjustify | outdent indent |  numlist bullist | forecolor backcolor' +
    ' removeformat | pagebreak | charmap emoticons | preview save print | insertfile link anchor codesample' +
    ' ltr rtl | showcomments addcomment paste pastetext',
  paste_as_text: true,
  paste_block_drop: false,
  forced_root_block: '',
  statusbar: false,
  menubar: 'file edit view insert format tools table tc help',
  spellchecker_whitelist: ['Ephox', 'Moxiecode'],
  tinycomments_mode: 'embedded',
  skin: useDarkMode ? 'oxide-dark' : 'oxide',
  content_css: useDarkMode ? 'dark' : 'default',
  paste_preprocess: function (plugin, args) {
    args.content += ' preprocess';
  },
  menu: {
    file: { title: 'File', items: 'newdocument' },
    edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
    insert: { title: 'Insert', items: 'link media | template hr' },
    view: { title: 'View', items: 'visualaid' },
    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | removeformat' },
    table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
    tools: { title: 'Tools', items: 'spellchecker code' }
  },
  width: '90%',
  height: '1600'
};
export const ACTIVE = 'active';
export const POPUP_HEIGHT = '550px';
export const POPUP_WIDTH = '1000px';



// WEBPACK FOOTER //
// ./src/app/util/constants.ts